const SHOW_TIERS = {
  FREE: 'free',
  NEW_MEDIA: 'new-media',
  TV_FILM: 'tv-film',
  STRIPE: 'stripe',
}

export { SHOW_TIERS }
